export const MAIN_PATH = '/'
export const ELASTICFORM_PATH = '/elasticform'
